import React from 'react';
import { openNewTab } from 'src/common/config/FunctionHelper';
import { localSeoAi as localSeoAiText } from 'src/common/config/TextMessage';

const LocalSeoAiHeader = () => {
  return (
    <React.Fragment>
      <div
        className="flex gap-2 cursor-pointer"
        onClick={() => {
          openNewTab(localSeoAiText.tutorialLink);
        }}
      >
        <img
          src={
            process.env.PUBLIC_URL +
            `/static/images/icons/keyword/book-open-02.svg`
          }
          alt="icon"
        />
        <p className="text-base font-bold text-left text-[var(--color-purple-deep-alt)] cursor-pointer">
          {localSeoAiText.tutorialText}
        </p>
      </div>
    </React.Fragment>
  );
};

export default LocalSeoAiHeader;
